import * as types from "./actionType";

export const fetchDataPipeline = () => ({
    type: types.DATA_PIPELINE_REQUESTED
})
